import { ProviderRow, ProviderType, SentRow } from "namirasoft-email-sender";
import { IEntityInfo, NSARouterMakerProps } from "namirasoft-account-react";
import { EmailSenderRoutes } from "./EmailSenderRoutes";
import { ProductUUID } from "namirasoft-api-product";
import { EmailSenderMenus } from "./EmailSenderMenus";
import { EmailSenderRouterProps } from "./EmailSenderRouterProps";
import { BaseColumnFormatter, BooleanFormatter, DateTimeFormatter, EmailFormatter, EnumFormatter, ForeColorFormatter, IDFormatter, IntegerFormatter, JsonFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { NamirasoftMap } from "namirasoft-site-map";
import { IStorageLocal } from "namirasoft-core";

export class EmailSenderEntities
{
	static provider(props: NSARouterMakerProps & EmailSenderRouterProps): IEntityInfo<ProviderRow, ProviderRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_EMAIL_SENDER,
			name: "provider",
			tables: [{ table: namirasoft.email_sender.tables.provider, required: true }],
			client: {
				getListURL: () => EmailSenderRoutes.ProviderList,
				getNewURL: () => EmailSenderRoutes.ProviderNew,
				getCopyURL: (id: string) => EmailSenderRoutes.ProviderCopy(id),
				getEditURL: (id: string) => EmailSenderRoutes.ProviderEdit(id),
				getViewURL: (id: string) => EmailSenderRoutes.ProviderView(id),
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.type, new EnumFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.e_verified, new ForeColorFormatter(new BooleanFormatter("Verified", "Not Yet"), { true: "green", false: "red" })),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.meta, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.limit, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.limit_count, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.limit_per_value, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.limit_per_unit, new StringFormatter(StringFormatterSizeType.Word)),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.provider.columns.updated_at, new DateTimeFormatter()),
					];
				},
				onCreate: async (entity) =>
				{
					let body = { ...entity, ...entity.meta };
					delete body.id;
					delete body.user_id;
					delete body.project_id;
					delete body.type;
					delete body.e_verified;
					delete body.meta;
					delete body.created_at
					delete body.updated_at;
					if (entity.type === ProviderType.AWS)
						return await props.servers.email_sender.aws.Create(body);
					if (entity.type === ProviderType.SMTP)
						return await props.servers.email_sender.smtp.Create(body);
					if (entity.type === ProviderType.Gmail)
					{
						let res = await props.servers.email_sender.gmail.Create(body);
						window.location.href = res.url;
						return null;
					}
					throw new Error("Wrong provider type");
				},
				onUpdate: async (id, entity) =>
				{
					let body = { ...entity, ...entity.meta };
					delete body.id;
					delete body.user_id;
					delete body.project_id;
					delete body.type;
					delete body.e_verified;
					delete body.meta;
					delete body.created_at
					delete body.updated_at;
					if (entity.type === ProviderType.AWS)
						return await props.servers.email_sender.aws.Update(id, body);
					if (entity.type === ProviderType.SMTP)
						return await props.servers.email_sender.smtp.Update(id, body);
					if (entity.type === ProviderType.Gmail)
					{
						let res = await props.servers.email_sender.gmail.Update(id, body);
						window.location.href = res.url;
						return null;
					}
					throw new Error("Wrong provider type");
				},
				getMenus: (getIDs, getRows) => { return { "Provider": [EmailSenderMenus.verify(getIDs, getRows), EmailSenderMenus.send(getIDs, getRows)] } }
			},
			server: {
				value_list: props.servers.email_sender.value.List,
				get: props.servers.email_sender.provider.Get,
				list: props.servers.email_sender.provider.List,
				create: async (entity) =>
				{
					if (entity.type === ProviderType.AWS)
					{
						let body = {
							workspace_id: entity.workspace_id,
							name: entity.name,
							region: entity.meta.region,
							access_key: entity.meta.access_key,
							secret_key: entity.meta.secret_key,
							from: entity.meta.from,
							limit: entity.limit,
							limit_count: entity.limit_count,
							limit_per_value: entity.limit_per_value,
							limit_per_unit: entity.limit_per_unit,
							provider_category: [], provider_field: [], provider_tag: [],
						}
						return await props.servers.email_sender.aws.Create(body)
					}
					if (entity.type === ProviderType.SMTP)
					{
						let body = {
							workspace_id: entity.workspace_id,
							name: entity.name,
							host: entity.meta.host,
							port: entity.meta.port,
							username: entity.meta.username,
							password: entity.meta.password,
							limit: entity.limit,
							limit_count: entity.limit_count,
							limit_per_value: entity.limit_per_value,
							limit_per_unit: entity.limit_per_unit,
							provider_category: [], provider_field: [], provider_tag: [],
						}
						return await props.servers.email_sender.smtp.Create(body);
					}
					throw new Error("Wrong provider type");
				},
				update: async (id, entity) =>
				{
					if (entity.type === ProviderType.AWS)
					{
						let body = {
							workspace_id: entity.workspace_id,
							name: entity.name,
							region: entity.meta.region,
							access_key: entity.meta.access_key,
							secret_key: entity.meta.secret_key,
							from: entity.meta.from,
							limit: entity.limit,
							limit_count: entity.limit_count,
							limit_per_value: entity.limit_per_value,
							limit_per_unit: entity.limit_per_unit,
							provider_category: [], provider_field: [], provider_tag: [],
						}
						return await props.servers.email_sender.aws.Update(id, body)
					}
					if (entity.type === ProviderType.SMTP)
					{
						let body = {
							workspace_id: entity.workspace_id,
							name: entity.name,
							host: entity.meta.host,
							port: entity.meta.port,
							username: entity.meta.username,
							password: entity.meta.password,
							limit: entity.limit,
							limit_count: entity.limit_count,
							limit_per_value: entity.limit_per_value,
							limit_per_unit: entity.limit_per_unit,
							provider_category: [], provider_field: [], provider_tag: [],
						}
						return await props.servers.email_sender.smtp.Update(id, body);
					}
					throw new Error("Wrong provider type");
				},
				delete: props.servers.email_sender.provider.Delete,
			}
		};
	}
	static sent(props: NSARouterMakerProps & EmailSenderRouterProps): IEntityInfo<SentRow, SentRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_EMAIL_SENDER,
			name: "sent",
			tables: [{ table: namirasoft.email_sender.tables.sent, required: true }],
			client: {
				getListURL: () => EmailSenderRoutes.SentList,
				getNewURL: null,
				getCopyURL: null,
				getEditURL: null,
				getViewURL: null,
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.sent.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.sent.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.sent.columns.session_id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.sent.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.sent.columns.provider_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.sent.columns.email, new EmailFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.sent.columns.title, new StringFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.sent.columns.message, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.sent.columns.successful, new ForeColorFormatter(new BooleanFormatter("Successful", "Failed"), { true: "green", false: "red" })),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.sent.columns.result, new StringFormatter(StringFormatterSizeType.Sentence)),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.sent.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.email_sender.tables.sent.columns.sent_at, new DateTimeFormatter()),
					];
				}
			},
			server: {
				value_list: props.servers.email_sender.value.List,
				get: props.servers.email_sender.sent.Get,
				list: props.servers.email_sender.sent.List,
				create: null,
				update: null,
				delete: null,
			}
		}
	}
}